module.exports = __webpack_public_path__ + "img/6.95643f52.svg";